export const redirectToUrl = (url: string, target = '_blank') => {
  const linkEl = document.createElement('a');
  linkEl.href = url;
  if (target) {
    linkEl.setAttribute('target', target);
  }

  linkEl.click();
};
